<template>
  <v-container>
    <!-- BOC:[breadcrumbs] -->
    <ABreadcrumb :items="breadcrumbs"></ABreadcrumb>
    <!-- EOC -->
    <v-card class="mx-auto pa-3" max-width="800" outlined min-height="200">
      <v-row class="mb-3">
        <v-col>
          <h2>Plan Info</h2>
        </v-col>
      </v-row>
      <ALoader :isLoading="planApi.isLoading"></ALoader>
      <div v-if="!planApi.isLoading && plan.Plan">
        <v-row class="mb-4">
          <v-col cols="12" md="4">
            <v-img
              :src="plan.Plan.imageUrl"
              :alt="plan.Plan.name"
              height="200"
              contain
              class="rounded"
            ></v-img>
          </v-col>
          <v-col cols="12" md="8">
            <h3 class="mb-3">{{ plan.Plan.name }}</h3>
            <p class="text-body-1 mb-3">{{ plan.Plan.description }}</p>
            <v-chip color="primary" class="mb-2">
              RM {{ plan.PaymentTransaction.PlanPricing.priceOriginal }}/ Year
            </v-chip>
          </v-col>
        </v-row>

        <!-- Plan Duration -->
        <v-row class="mb-4">
          <v-col cols="12">
            <v-card outlined class="pa-3">
              <h4 class="mb-3">Subscription Period</h4>
              <v-row>
                <v-col cols="12" md="6">
                  <div class="d-flex align-center mb-2">
                    <v-icon color="green" class="mr-2"
                      >mdi-calendar-start</v-icon
                    >
                    <div>
                      <div class="text-caption">Start Date</div>
                      <div class="font-weight-medium">
                        {{ formatDate(plan.timestampStart) }}
                      </div>
                    </div>
                  </div>
                </v-col>
                <v-col cols="12" md="6">
                  <div class="d-flex align-center mb-2">
                    <v-icon color="orange" class="mr-2"
                      >mdi-calendar-end</v-icon
                    >
                    <div>
                      <div class="text-caption">End Date</div>
                      <div class="font-weight-medium">
                        {{ formatDate(plan.timestampEnd) }}
                      </div>
                    </div>
                  </div>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <div class="d-flex align-center">
                    <v-icon
                      :color="plan.isAutoRenewal ? 'green' : 'grey'"
                      class="mr-2"
                    >
                      {{
                        plan.isAutoRenewal ? "mdi-refresh" : "mdi-refresh-off"
                      }}
                    </v-icon>
                    <div>
                      <div class="text-caption">Auto Renewal</div>
                      <div v-if="!plan.isAutoRenewal" class="font-weight-medium">
                      Disabled
                      </div>
                      <v-btn
                        color="warning"
                        small
                        v-else
                        :to="{ name: 'PageFamilyPlanAutoRenewalStop' }"
                        class="mr-2"
                      >
                        <v-icon small left>mdi-stop-circle</v-icon>
                        Disable
                      </v-btn>
                    </div>
                  </div>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
        </v-row>

        <!-- Features List -->
        <v-row class="mb-4">
          <v-col cols="12">
            <v-card outlined class="pa-3">
              <h4 class="mb-3">Plan Features</h4>
              <v-list dense>
                <v-list-item
                  v-for="feature in plan.Feature"
                  :key="feature.id"
                  class="px-0"
                >
                  <v-list-item-icon>
                    <v-icon color="success">mdi-check-circle</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>{{ feature.name }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-card>
          </v-col>
        </v-row>

        <!-- Action Buttons -->
        <!-- <v-row>
          <v-col cols="12">
            <v-card outlined class="pa-3">
              <h4 class="mb-3">Subscription Action</h4>
              <v-btn
                color="warning"
                :disabled="!plan.isAutoRenewal"
                :to="{name:'PageFamilyPlanAutoRenewalStop'}"
                class="mr-2"
              >
                <v-icon left>mdi-stop-circle</v-icon>
                Disable Auto Renewal
              </v-btn>
            </v-card>
          </v-col>
        </v-row> -->
      </div>

      <!-- Error State -->
      <v-alert v-if="planApi.isError" type="error" class="mt-3">
        Failed to load plan details. Please try again.
      </v-alert>
    </v-card>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
export default {
  components: {},
  computed: {
    size() {
      const size = { xs: "small", sm: "small", lg: "large", xl: "x-large" }[
        this.$vuetify.breakpoint.name
      ];
      return size ? { [size]: true } : {};
    },
    ...mapState({
      auth: (state) => state.auth.data,
    }),
  },
  props: [
    //
  ],
  data: () => ({
    //BOC:[breadcrumbs]
    breadcrumbs: [],
    //EOC
    //BOC:[api]
    planApi: {
      isLoading: false,
      isError: false,
      error: null,
      url: null,
    },
    //EOC
    plan: {},
    showCancelDialog: false,
  }),
  created() {
    this.breadcrumbs = [
      {
        text: "Dashboard",
        to: { name: "PageFamilyDashboard" },
        exact: true,
      },
      {
        text: "My Plan",
        to: {
          name: "PageFamilyPlanRead",
        },
        exact: true,
      },
    ];

    this.planApi.method = "GET";
    this.planApi.url =
      this.$api.servers.sso +
      "/api/v1/" +
      this.$_getLocale() +
      "/backend/account/plan/myPlan";

    this.planApi.callbackReset = () => {
      this.planApi.isLoading = true;
      this.planApi.isError = false;
    };

    this.planApi.callbackError = (e) => {
      this.planApi.isLoading = false;
      this.planApi.isError = true;
      this.planApi.error = e;
    };

    this.planApi.callbackSuccess = (resp) => {
      this.planApi.isLoading = false;
      this.plan = resp.data;
    };
  },
  mounted() {
    this.$api.fetch(this.planApi);
  },
  methods: {
    formatDate(dateString) {
      if (!dateString) return "N/A";
      const date = new Date(dateString);
      return date.toLocaleDateString("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      });
    },
  },
};
</script>

<style scoped>
.form-content {
  width: 600px !important;
}

.v-card {
  transition: all 0.3s ease;
}

.v-list-item {
  padding-left: 0;
}

.v-list-item-icon {
  margin-right: 12px;
}
</style>